import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'state';

export enum AlertNotificationType { // eslint-disable-line
  Success = 'success',
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
}

export interface AlertNotification {
  id: string;
  message: string;
  type: AlertNotificationType;
}

export interface NotificationState {
  notification?: AlertNotification;
}

export const initialState: NotificationState = {
  notification: undefined,
};

export const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setNotificationAction: (state, action) => {
      state.notification = action.payload;
    },
    clearNotificationAction: (state) => {
      state.notification = undefined;
    },
  },
});

export const {
  setNotificationAction,
  clearNotificationAction,
} = notificationSlice.actions;

export const notificationSelector = (state: RootState):
  AlertNotification | undefined => state.notification.notification;
